import { useKeycloak } from "@react-keycloak/web";
import { Fragment, ReactNode } from "react";
import { Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import { Role } from "../types";

interface PrivateRouteProps {
  children: ReactNode;
  roles: Role[];
}

export default function PrivateRoute({ children, roles }: PrivateRouteProps) {
  const isAuth = useAuth(roles);
  const { keycloak } = useKeycloak();

  if (isAuth && keycloak.authenticated) {
    return <Fragment>{children}</Fragment>;
  }

  return <Navigate to="/sign-in" />;
  // return <Navigate to="/organization/dashboard" />;
}
